
module.exports = {
  address: '0xf3AE5d769e153Ef72b4e3591aC004E89F48107a1',
  address_test: '0xafa4c15125f71f2a10cebcc8c4f125e66169d09f',
  abi: require('./DPR.abi.json')
}
